import { moduleProviderFactory } from 'core/providers';
import { SellerList, SellerEdit } from 'modules/seller/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.seller',
				pattern: '/sellers',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.seller.list',
						pattern: '',
						component: SellerList,
					},
					{
						name: 'master.app.main.seller.create',
						pattern: '/create',
						component: SellerEdit,
					},
					{
						name: 'master.app.main.seller.edit',
						pattern: '/edit/:id',
						component: SellerEdit,
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/seller/config.js